import { Component, forwardRef, Input } from '@angular/core'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input'
import { NgxMatDatepickerActions, NgxMatDatepickerApply, NgxMatDatepickerCancel, NgxMatDatepickerInput, NgxMatDatetimepicker } from '@ngxmc/datetime-picker'
import { AppMatDatepickerToggle } from './datetime-picker-toggle/datetime-picker-toggle.component'

@Component({
  selector: 'app-datetime-picker',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatInput,
    NgxMatDatepickerActions,
    AppMatDatepickerToggle,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    MatSuffix,
    NgxMatDatepickerCancel,
    NgxMatDatepickerApply,
    TranslateModule,
    MatFormField,
    MatLabel,
  ],
  templateUrl: './datetime-picker.component.html',
  styleUrl: './datetime-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true,
    },
  ],
})
export class DatetimePickerComponent implements ControlValueAccessor {
  @Input()
  required = true

  @Input()
  translationKey = 'COMMON.DATE'

  value: Date | null = null

  private onChange: (value: Date | null) => void = () => {}
  private onTouched: () => void = () => {}

  writeValue(value: Date | string | null): void {
    const normalizedValue = this.normalizeValue(value)
    this.value = normalizedValue
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }

  onValueChange(newValue: Date | null) {
    this.value = newValue
    this.onChange(newValue)
    this.onTouched()
  }

  private normalizeValue(newValue: Date | string | null) {
    if (newValue === null || newValue === '') {
      return null
    } else if (typeof newValue === 'string') {
      const date = new Date(newValue)
      return !isNaN(date.getTime()) ? date : null
    } else {
      return newValue instanceof Date ? newValue : null
    }
  }
}
